import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms'; 
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { HttpService } from '../../services/http/http.service';
import { IAppState } from '../../interfaces/app-state';
import { BaseLayoutComponent } from '../base-layout/base-layout.component';
import * as SettingsActions from '../../store/actions/app-settings.actions';

@Component({
  selector: 'horizontal-layout',
  templateUrl: './horizontal.component.html',
  styleUrls: [
    '../base-layout/base-layout.component.scss',
    './horizontal.component.scss'
  ]
})
export class HorizontalLayoutComponent extends BaseLayoutComponent implements OnInit {
  verified: any;
  constructor(
    store: Store<IAppState>,
    fb: FormBuilder,
    httpSv: HttpService,
    router: Router,
    elRef: ElementRef
  ) {
    super(store, fb, httpSv, router, elRef);
  }
  restaurant_image
  restoID
  resto=[]
  ngOnInit() {
    super.ngOnInit();
    this.restoID = localStorage.getItem('restoID');
    this.getdata()
    this.getSearchData('assets/data/menu-horizontal.json');
    this.store.dispatch(new SettingsActions.Update({ layout: 'horizontal' }));
  }
  getdata() {
    this.httpSv.getReturant(this.restoID).subscribe(
      response => {
        if (response['status'] == true) {
          // Swal.fire("Password Successfully Changed")
          // this.router.navigate(['/public/sign-in']);
          // this.appointments = response.result.data;
          // this.router.navigate(['/public/sign-in']);
          this.resto = response['result'].data;
          this.restaurant_image = this.resto['logo'];
          this.verified = this.resto['restaurant_verified']
         
          //  this.getrestoDetails();
        }
        else {
          // this.resetFormLoad = false;
          // Swal.fire("Something Went Wrong")
        }

      }
    )
  }
}
